import { WixSupportChatSDK } from './WixSupportChatSDK';

window.WixSupportChatSDK = new WixSupportChatSDK();
